import React from 'react';
import { string } from 'prop-types';

import { colors, Container, Typography } from '@ajaibid/components';
import { formatCurrency } from '@ajaibid/utils';
import stockService from '@services/stock';

import { useStockBuySellContext } from '../../hooks';

const OrderSummaryTop = (props) => {
  const { code } = props;

  const { data: stockAboutData } = stockService.detail.about.useAbout(code);

  const { formState, formKey } = useStockBuySellContext();

  return (
    <Container padding="24px 48px 0px">
      <img
        height={32}
        width={32}
        src={stockAboutData?.icon_url}
        alt=""
        data-testid="img-stockLogo"
      />

      <Typography
        type="body"
        size="lg"
        bold
        align="center"
        margin={0}
        marginTop={8}
        data-testid="txt-stockCode"
      >
        {stockAboutData?.code}
      </Typography>
      <Typography type="label" align="center" margin={0} data-testid="txt-stockName">
        {stockAboutData?.name}
      </Typography>

      <Typography
        type="heading"
        bold
        align="center"
        margin={0}
        marginTop={16}
        data-testid="txt-total"
      >
        {formatCurrency(formState[formKey.CALC_ORDER_TOTAL], 'IDR')}
      </Typography>
      <Typography
        type="body"
        color={colors.NEUTRAL_7}
        align="center"
        marginTop={4}
        data-testid="txt-lotCount"
      >
        {formatCurrency(formState[formKey.INPUT_LOT_COUNT], 'Lot')}
      </Typography>
    </Container>
  );
};

OrderSummaryTop.propTypes = {
  code: string,
};

OrderSummaryTop.defaultProps = {
  code: '',
};

export default OrderSummaryTop;
